module.exports = __webpack_public_path__ + "img/app-taipei.66cf98b7.png";